import React from 'react';
import {
  Box,
  Button,
  LinearProgress
} from '@mui/material';
import {
  PlayArrow
} from '@mui/icons-material';
import './UploadButton.css';

const UploadButton = ({ onUpload, files, uploading }) => {
  const pendingFiles = files.filter(f => f.status === 'pending');
  
  if (pendingFiles.length === 0) return null;

  return (
    <Box className="upload-button-container">
      <Button
        variant="contained"
        startIcon={uploading ? <LinearProgress className="upload-progress-icon" /> : <PlayArrow className="play-icon" />}
        onClick={onUpload}
        disabled={uploading}
        className={`upload-btn ${uploading ? 'uploading' : ''}`}
      >
        {uploading ? 'Uploading...' : `Upload ${pendingFiles.length} File${pendingFiles.length > 1 ? 's' : ''}`}
      </Button>
    </Box>
  );
};

export default UploadButton;
